import { render } from "./ContratoModal.vue?vue&type=template&id=3ad2b8a8"
import script from "./ContratoModal.vue?vue&type=script&lang=js"
export * from "./ContratoModal.vue?vue&type=script&lang=js"

import "./ContratoModal.vue?vue&type=style&index=0&id=3ad2b8a8&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__